import { Button } from '@1trading/react/components/ui/button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

const LogoutButton = React.forwardRef<React.ElementRef<typeof Button>, Omit<React.ComponentPropsWithoutRef<typeof Button>, 'onClick'>>(({ children, ...props }, ref) => {
  const { signoutRedirect } = useAuth();
  const { t } = useTranslation();

  return (
    <Button onClick={() => signoutRedirect()} ref={ref} {...props}>
      {children || t('logout')}
    </Button>
  );
});
LogoutButton.displayName = 'LogoutButton';

export default LogoutButton;
